import gql from "graphql-tag";
import { taskServiceTypeDef } from "../definitions/task-service-type-def";
import { errorsTypeDef } from "../../errors/errors-type-def";

const taskByIdQuery = gql`
  query taskById($id: String!) {
    task {
      byId(input: {
        id: $id
      }) {
        output {
          ${taskServiceTypeDef}
        }
        errors {
          ${errorsTypeDef}
        }
      }
    }
  }
`;

export default taskByIdQuery;
